import React, { useEffect } from 'react';
import { BrowserRouter, HashRouter, Route, Switch } from 'react-router-dom';
import { Icon, message, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '@/views/layout';
import Login from '@/views/Login';
import AuthRouter from '@/views/auth/AuthRouter';
import { setUserInfo } from '../redux/actions/userInfo';
import { getUserInfo } from '../services/Login';
import { setLoading } from '../redux/actions/app';

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const Router = () => {

	const dispatch = useDispatch();
	const loading = useSelector(state => state.app.loading);
	useEffect(() => {
		window.setLoading = (value) => dispatch(setLoading(value));
		const init = async () => {
			try {
				const userInfo = await getUserInfo();
				dispatch(setUserInfo(userInfo.data));
			} catch (error) {
				message.error('Phiên đăng nhập hết hạn');
				localStorage.removeItem('token');
				dispatch(setUserInfo(null));
				window.location.href = '/login';
			}
		};
		if (window.location.pathname === '/login') return;
		init();
	}, []);

	return (
		<Spin id={'loading-container'} spinning={loading} indicator={antIcon}>
			<BrowserRouter basename={"/"}>
				<Switch>
					<Route component={Login} exact path="/login" />
					<AuthRouter path="/" component={Layout} />
				</Switch>
			</BrowserRouter>
		</Spin>
	);
};

export default Router;
